import script from "./Games.vue?vue&type=script&setup=true&lang=js"
export * from "./Games.vue?vue&type=script&setup=true&lang=js"

import "./Games.vue?vue&type=style&index=0&id=15db4dc6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15db4dc6"]])

export default __exports__